<template>
  <div
    class="bg-[var(--fundoForm)] w-full p-2 rounded-md flex justify-center items-center text-[var(--text)]"
  >
    <form
      @submit.prevent="onSubmit"
      class="flex flex-col items-left gap-2 text-black outline-none focus:ring-2 focus:ring-[#2e2e48] p-2"
    >
      <!-- <h1 style="color: var(--titulo);">Schema Atual: {{ currentSchema }}</h1> -->
      <h1 style="color: var(--titulo)">Dados Gerais da Empresa</h1>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="nome"
        id="nome"
        label="Nome:"
        placeholder="Nome"
      />
      <span v-if="errors.nome" class="text-red-500">{{ errors.nome }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="morada"
        id="morada"
        label="Morada:"
        placeholder="Morada"
      />
      <span v-if="errors.morada" class="text-red-500">{{ errors.morada }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="codigoPostal"
        id="codigoPostal"
        label="Código Postal:"
        placeholder="Código Postal"
      />
      <span v-if="errors.codigoPostal" class="text-red-500">{{
        errors.codigoPostal
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="telefone"
        id="telefone"
        label="Telefone:"
        placeholder="Telefone"
      />
      <span v-if="errors.telefone" class="text-red-500">{{
        errors.telefone
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="email"
        id="email"
        label="Email:"
        type="email"
        placeholder="Email"
      />
      <span v-if="errors.email" class="text-red-500">{{ errors.email }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="url"
        id="url"
        label="URL:"
        type="url"
        placeholder="URL"
      />
      <span v-if="errors.url" class="text-red-500">{{ errors.url }}</span>

      <FormSelect
        v-model="selectedClassificacao"
        id="classificacao"
        label="Classificação:"
        :options="classificacoes"
        placeholder="Seleciona a Classificação"
      />
      <span v-if="errors.selectedClassificacao" class="text-red-500">{{
        errors.selectedClassificacao
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="nif"
        id="nif"
        label="NIF:"
        placeholder="NIF"
      />
      <span v-if="errors.nif" class="text-red-500">{{ errors.nif }}</span>

      <div class="w-full grid grid-cols-2.5 items-center gap-2">
        <FormSelect
          v-model="selectedRegiaoFiscal"
          id="regiaoFiscal"
          label="Região Fiscal:"
          :options="regiaoFiscais"
          placeholder="Seleciona a Região Fiscal"
        />
        <span v-if="errors.selectedRegiaoFiscal" class="text-red-500">{{
          errors.selectedRegiaoFiscal
        }}</span>

        <FormSelect
          v-model="selectedRegiaoFiscal2"
          id="regiaoFiscal2"
          label="Sub-região:"
          :options="regiaoFiscal2s"
          placeholder="Seleciona a Sub-região"
        />
        <span v-if="errors.selectedRegiaoFiscal2" class="text-red-500">{{
          errors.selectedRegiaoFiscal2
        }}</span>
      </div>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="capitalSocial"
        id="capitalSocial"
        label="Capital Social:"
        placeholder="Capital Social"
      />
      <span v-if="errors.capitalSocial" class="text-red-500">{{
        errors.capitalSocial
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="conservatoriaDoRegistoComercial"
        id="conservatoriaDoRegistoComercial"
        label="Conservatória do Registo Comercial:"
        placeholder="Conservatória do Registo Comercial"
      />
      <span
        v-if="errors.conservatoriaDoRegistoComercial"
        class="text-red-500"
        >{{ errors.conservatoriaDoRegistoComercial }}</span
      >

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="numero"
        id="numero"
        label="Número:"
        placeholder="Número"
      />
      <span v-if="errors.numero" class="text-red-500">{{ errors.numero }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="codigoDaTabelaDeAtividade"
        id="codigoDaTabelaDeAtividade"
        label="Código da Tabela de Atividade:"
        placeholder="Código da Tabela de Atividade"
      />
      <span v-if="errors.codigoDaTabelaDeAtividade" class="text-red-500">{{
        errors.codigoDaTabelaDeAtividade
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="volumeDeNegocios"
        id="volumeDeNegocios"
        label="Volume de Negócios:"
        type="number"
        placeholder="Volume de Negócios"
      />
      <span v-if="errors.volumeDeNegocios" class="text-red-500">{{
        errors.volumeDeNegocios
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="numerosDeEstabelecimento"
        id="numerosDeEstabelecimento"
        label="Números de Estabelecimento:"
        type="number"
        placeholder="Números de Estabelecimento"
      />
      <span v-if="errors.numerosDeEstabelecimento" class="text-red-500">{{
        errors.numerosDeEstabelecimento
      }}</span>

      <h1 style="color: var(--titulo)">Informação Bancária</h1>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="numeroBancario"
        id="numeroBancario"
        label="Número Bancário:"
        placeholder="Número Bancário"
      />
      <span v-if="errors.numeroBancario" class="text-red-500">{{
        errors.numeroBancario
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="iban"
        id="iban"
        label="IBAN:"
        placeholder="IBAN"
      />
      <span v-if="errors.iban" class="text-red-500">{{ errors.iban }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="swiftBic"
        id="swiftBic"
        label="SWIFT/BIC:"
        placeholder="SWIFT/BIC"
      />
      <span v-if="errors.swiftBic" class="text-red-500">{{
        errors.swiftBic
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="identificacaoDoCredor"
        id="identificacaoDoCredor"
        label="Identificação do Credor:"
        placeholder="Identificação do Credor"
      />
      <span v-if="errors.identificacaoDoCredor" class="text-red-500">{{
        errors.identificacaoDoCredor
      }}</span>

      <h1 style="color: var(--titulo)">Dados Fiscais</h1>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="cae"
        id="cae"
        label="CAE:"
        placeholder="CAE"
      />
      <span v-if="errors.cae" class="text-red-500">{{ errors.cae }}</span>

      <h1 style="color: var(--titulo)">Outros NIF's</h1>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="toc"
        id="toc"
        label="TOC:"
        placeholder="TOC"
      />
      <span v-if="errors.toc" class="text-red-500">{{ errors.toc }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="repLegal"
        id="repLegal"
        label="Rep. Legal:"
        placeholder="Rep. Legal"
      />
      <span v-if="errors.repLegal" class="text-red-500">{{
        errors.repLegal
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="roc"
        id="roc"
        label="ROC:"
        placeholder="ROC"
      />
      <span v-if="errors.roc" class="text-red-500">{{ errors.roc }}</span>

      <h1 style="color: var(--titulo)">Repartição de Finanças</h1>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="concelho"
        id="concelho"
        label="Concelho:"
        placeholder="Concelho"
      />
      <span v-if="errors.concelho" class="text-red-500">{{
        errors.concelho
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="bairroFiscal"
        id="bairroFiscal"
        label="Bairro Fiscal:"
        placeholder="Bairro Fiscal"
      />
      <span v-if="errors.bairroFiscal" class="text-red-500">{{
        errors.bairroFiscal
      }}</span>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="codigo"
        id="codigo"
        label="Código:"
        placeholder="Código"
      />
      <span v-if="errors.codigo" class="text-red-500">{{ errors.codigo }}</span>

      <h1 style="color: var(--titulo)">Taxa da Derrama</h1>

      <FormInput
        :style="{ color: 'var(--text)' }"
        v-model="taxaDerrama"
        id="taxaDerrama"
        label="Taxa da Derrama:"
        type="number"
        placeholder="Taxa da Derrama"
      />
      <span v-if="errors.taxaDerrama" class="text-red-500">{{
        errors.taxaDerrama
      }}</span>

      <div class="text-right">
        <button
          v-if="validPermission('C0011')"
          type="submit"
          :disabled="isLoading"
          class="button px-4 py-1 rounded-lg shadow-lg hover:bg-sky-700 text-white"
        >
          {{ isLoading ? "Salvando..." : "Salvar" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { id as loggedID } from '@/extraData'
import { toast } from 'vue3-toastify'
import permissionMixin from '@/permissionMixin.js'
import FormInput from '@/components/FormInput.vue'
import FormSelect from '@/components/FormSelect.vue'
import axios from "axios";

export default {
  mixins: [permissionMixin],
  components: {
    FormInput,
    FormSelect
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_URL_BASE,
      currentSchema: '',
      // schemaAtual: '',
      nome: '',
      morada: '',
      codigoPostal: '',
      telefone: '',
      fax: '',
      email: '',
      url: '',
      selectedClassificacao: '',
      classificacoes: [
        { id: 1, nome: 'Classificação 1' },
        { id: 2, nome: 'Classificação 2' }
      ],
      nif: '',
      selectedRegiaoFiscal: '',
      selectedRegiaoFiscal2: '',
      regiaoFiscais: [
        { id: 1, nome: 'Região 1' },
        { id: 2, nome: 'Região 2' }
      ],
      regiaoFiscal2s: [
        { id: 1, nome: 'Sub-região 1' },
        { id: 2, nome: 'Sub-região 2' }
      ],
      capitalSocial: '',
      conservatoriaDoRegistoComercial: '',
      numero: '',
      codigoDaTabelaDeAtividade: '',
      volumeDeNegocios: '',
      numerosDeEstabelecimento: '',
      numeroBancario: '',
      iban: '',
      swiftBic: '',
      identificacaoDoCredor: '',
      cae: '',
      toc: '',
      repLegal: '',
      roc: '',
      concelho: '',
      bairroFiscal: '',
      codigo: '',
      taxaDerrama: '',
      isLoading: false,
      errors: {}
    }
  },
  async mounted() {
    await this.fetchSchema();   // 1. Carrega schema atual
    await this.fetchEmpresaDB(); // 2. Carrega dados da empresa no schema atual
  }
  ,
  // mounted() {
  //   this.fetchEmpresaDB();
  //   this.fetchSchema();
  // },
  computed: {
    formData() {
      return {
        empresa: this.nome,
        morada: this.morada,
        codigo_postal: this.codigoPostal,
        telefone: this.telefone,
        fax: this.fax,
        email: this.email,
        url: this.url,
        classificacao: this.selectedClassificacao,
        nif: this.nif,
        regiao_fiscal: this.selectedRegiaoFiscal,
        capital_social: this.capitalSocial,
        conservat_do_registo_comercial: this.conservatoriaDoRegistoComercial,
        numero: this.numero,
        codigo_da_tabela_de_atividades: this.codigoDaTabelaDeAtividade,
        volume_de_negocios: this.volumeDeNegocios,
        numero_de_estabelecimento: this.numerosDeEstabelecimento,
        numero_de_bancario: this.numeroBancario,
        iban: this.iban,
        swift_bic: this.swiftBic,
        identificao_de_creador: this.identificacaoDoCredor,
        cae: this.cae,
        toc: this.toc,
        rep_legal: this.repLegal,
        roc: this.roc,
        concelho: this.concelho,
        bairro_fiscal: this.bairroFiscal,
        codigo: this.codigo,
        derrama: this.taxaDerrama
      }
    }
  },
  methods: {
    async fetchSchema() {
      try {
        const response = await axios.get(`${this.baseURL}/api/v1/schema/atual`);
        if (response.data && response.data.schema) {
          this.currentSchema = response.data.schema;
        } else {
          this.currentSchema = "Schema não encontrado";
        }
      } catch (error) {
        console.error("Erro ao buscar schema atual:", error);
        this.currentSchema = "Erro ao carregar schema";
      }
    }
    ,
    //   async fetchSchema() {
    //   try {
    //     const response = await axios.get(`${this.baseURL}/api/v1/schema/atual`);
    //     if (response.data && response.data.schema) {
    //       this.currentSchema = response.data.schema;
    //     } else {
    //       this.currentSchema = "Schema não encontrado";
    //     }
    //   } catch (error) {
    //     console.error("Erro ao buscar empresa atual:", error);
    //     this.currentSchema = "Erro ao carregar empresa";
    //   }
    // },
        async fetchEmpresaDB() {
      try {
        // Garante que o schema atual foi carregado antes de buscar os dados da empresa
        if (!this.currentSchema) {
          await this.fetchSchema();
        }

        // Usando axios em vez de fetch
        const response = await axios.get(`${this.baseURL}/api/v1/empresa/nome/`);

        // Os dados já estão em response.data com axios
        const data = response.data;

        // Preenchendo os dados da empresa nos campos do formulário
        this.nome = data.nome || '';
        this.morada = data.morada || '';
        this.codigoPostal = data.codigo_postal || '';
        this.telefone = data.telefone || '';
        this.fax = data.fax || '';
        this.email = data.email || '';
        this.url = data.url || '';
        this.selectedClassificacao = data.classificacao || '';
        this.nif = data.nif || '';
        this.selectedRegiaoFiscal = data.regiao_fiscal || '';
        this.capitalSocial = data.capital_social || '';
        this.conservatoriaDoRegistoComercial = data.conservat_do_registo_comercial || '';
        this.numero = data.numero || '';
        this.codigoDaTabelaDeAtividade = data.codigo_da_tabela_de_atividades || '';
        this.volumeDeNegocios = data.volume_de_negocios || '';
        this.numerosDeEstabelecimento = data.numero_de_estabelecimento || '';
        this.numeroBancario = data.numero_de_bancario || '';
        this.iban = data.iban || '';
        this.swiftBic = data.swift_bic || '';
        this.identificacaoDoCredor = data.identificao_de_creador || '';
        this.cae = data.cae || '';
        this.toc = data.toc || '';
        this.repLegal = data.rep_legal || '';
        this.roc = data.roc || '';
        this.concelho = data.concelho || '';
        this.bairroFiscal = data.bairro_fiscal || '';
        this.codigo = data.codigo || '';
        this.taxaDerrama = data.derrama || '';
      } catch (error) {
        console.error('Erro ao buscar dados da empresa:', error);
        toast.error('Erro ao carregar dados da empresa', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000
        });
      }
    },

    validateForm() {
      this.errors = {}
      if (!this.nome) this.errors.nome = 'O campo Nome é obrigatório.'
      if (!this.morada) this.errors.morada = 'O campo Morada é obrigatório.'
      if (!this.codigoPostal) this.errors.codigoPostal = 'O campo Código Postal é obrigatório.'
      if (!this.telefone) this.errors.telefone = 'O campo Telefone é obrigatório.'
      if (!this.email) this.errors.email = 'O campo Email é obrigatório.'
      if (!this.url) this.errors.url = 'O campo URL é obrigatório.'
      if (!this.selectedClassificacao) this.errors.selectedClassificacao = 'O campo Classificação é obrigatório.'
      if (!this.nif) this.errors.nif = 'O campo NIF é obrigatório.'
      if (!this.selectedRegiaoFiscal) this.errors.selectedRegiaoFiscal = 'O campo Região Fiscal é obrigatório.'
      if (!this.capitalSocial) this.errors.capitalSocial = 'O campo Capital Social é obrigatório.'
      if (!this.conservatoriaDoRegistoComercial) this.errors.conservatoriaDoRegistoComercial = 'O campo Conservatória do Registo Comercial é obrigatório.'
      if (!this.numero) this.errors.numero = 'O campo Número é obrigatório.'
      if (!this.codigoDaTabelaDeAtividade) this.errors.codigoDaTabelaDeAtividade = 'O campo Código da Tabela de Atividade é obrigatório.'
      if (!this.volumeDeNegocios) this.errors.volumeDeNegocios = 'O campo Volume de Negócios é obrigatório.'
      if (!this.numerosDeEstabelecimento) this.errors.numerosDeEstabelecimento = 'O campo Números de Estabelecimento é obrigatório.'
      if (!this.numeroBancario) this.errors.numeroBancario = 'O campo Número Bancário é obrigatório.'
      if (!this.iban) this.errors.iban = 'O campo IBAN é obrigatório.'
      if (!this.swiftBic) this.errors.swiftBic = 'O campo SWIFT/BIC é obrigatório.'
      if (!this.identificacaoDoCredor) this.errors.identificacaoDoCredor = 'O campo Identificação do Credor é obrigatório.'
      if (!this.cae) this.errors.cae = 'O campo CAE é obrigatório.'
      if (!this.toc) this.errors.toc = 'O campo TOC é obrigatório.'
      if (!this.repLegal) this.errors.repLegal = 'O campo Rep. Legal é obrigatório.'
      if (!this.roc) this.errors.roc = 'O campo ROC é obrigatório.'
      if (!this.concelho) this.errors.concelho = 'O campo Concelho é obrigatório.'
      if (!this.bairroFiscal) this.errors.bairroFiscal = 'O campo Bairro Fiscal é obrigatório.'
      if (!this.codigo) this.errors.codigo = 'O campo Código é obrigatório.'
      if (!this.taxaDerrama) this.errors.taxaDerrama = 'O campo Taxa da Derrama é obrigatório.'
      return Object.keys(this.errors).length === 0
    },
       async onSubmit() {
      if (!this.validateForm()) {
        toast.error('Por favor, preencha todos os campos obrigatórios.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000
        });
        return;
      }
    
      this.isLoading = true;
    
      try {
        // Garante que o schema atual foi carregado antes de enviar os dados
        if (!this.currentSchema) {
          await this.fetchSchema();
        }
    
        // Usando axios em vez de fetch
        const response = await axios.post(
          `${this.baseURL}/api/v1/dadosempresa/registrar/`, 
          this.formData
        );
    
        // Se chegou aqui, a resposta foi bem-sucedida
        toast.success('Dados da empresa salvos com sucesso!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000
        });
    
        // Recarrega os dados para refletir a atualização
        await this.fetchEmpresaDB();
      } catch (error) {
        console.error('Erro ao salvar os dados da empresa:', error);
        
        // Extrai mensagens de erro mais específicas se disponíveis
        const errorMessage = error.response?.data?.message || 'Erro ao salvar os dados. Tente novamente.';
        
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000
        });
      } finally {
        this.isLoading = false;
      }
    }

  }
}
</script>

<style scoped>
.button {
  background-color: var(--button);
  color: var(--label);
  cursor: pointer;
}

.button[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}

.button:hover:not([disabled]) {
  filter: brightness(0.9);
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}
</style>
